import(/* webpackMode: "eager" */ "/codebuild/output/src369475402/src/rmh-platform/apps/rmh-patient/app/error.tsx");
